import { type TouchList } from 'react';

import { Point } from '../types/point.js';

const getEuclideanDistance = (
  { x: xA, y: yA }: Point,
  { x: xB, y: yB }: Point,
) => Math.sqrt(Math.pow(xB - xA, 2) + Math.pow(yB - yA, 2));

export const getTouchesDistance = (touches: TouchList) => {
  if (touches.length < 2) {
    return 0;
  }

  const fingerOne = { x: touches[0].clientX, y: touches[0].clientY };
  const fingerTwo = { x: touches[1].clientX, y: touches[1].clientY };
  return getEuclideanDistance(fingerOne, fingerTwo);
};
